// LLM tool control

"use strict";

/**
 * Normalizes tool arguments turning them into lowercase
 * @param args The arguments
 * @returns The arguments with lowercase names
 */
export function normalizeToolArguments(args: Record<string, any>): Record<string, any> {
    const result: Record<string, any> = Object.create(null);

    if (args) {
        for (const key of Object.keys(args)) {
            result[key.toLowerCase()] = args[key];
        }
    }

    return result;
}

/**
 * Gets the tool argument
 * @param args The arguments
 * @param nameAlternatives The argument possible names. Provide multiple alternatives in case the LLM confuses the argument.
 * @returns The value, or undefined
 */
export function getToolArgument(args: Record<string, any>, nameAlternatives: string[]): any {
    args = normalizeToolArguments(args);
    nameAlternatives = nameAlternatives.map((a) => a.toLocaleLowerCase());

    for (const alternative of nameAlternatives) {
        if (args[alternative] !== undefined) {
            return args[alternative];
        }
    }

    return undefined;
}

/**
 * Gets a single tool argument from the arguments list
 * @param args The arguments
 * @returns A single argument value, or undefined
 */
export function getSingleToolArgument(args: Record<string, any>): any {
    for (const key of Object.keys(args)) {
        return args[key];
    }

    return undefined;
}
